<template>
  <div class="px-1 mb-3">
    <div class="form-row">
      <div class="form-group form-rounded mb-0 mr-1">
        <select2
          class="search-group-height"
          id="s2_demo2"
          :options="typeList"
          v-model="selectType"
          :disabled="$route.name === 'Library' ? true : false"
        >
        </select2>
      </div>
      <div class="form-group form-rounded mb-0 mr-1">
        <div class="input-group">
          <input
            type="text"
            class="form-control search-group-height"
            :placeholder="$t('search-materials')"
            v-model="searchRname"
          />
          <div class="input-group-append ">
            <div
              class="btn btn-secondary btn-outline btn-icon btn-rounded
              search-group-height"
              type="button"
            >
              <i class="zmdi zmdi-search text-secondary"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group form-rounded mb-0 mr-1">
        <select2
          id="s2_demo3"
          :options="sortTypeList"
          v-model="selectSortType"
          :settings="{ width: '100%', minWidth: '220px' }"
        >
        </select2>
      </div>
      <div
        v-if="haveLevel && $route.name !== 'Library'"
        class="form-group form-rounded mb-0 text-secondary"
        data-dismiss="modal"
        data-toggle="modal"
        data-target="#filterModal"
        @click="setAlllevel = ''"
      >
        <div
          class="btn btn-secondary btn-outline btn-icon btn-rounded d-flex justify-content-center align-items-center"
        >
          <i class="zmdi zmdi-filter-list mx-0"></i>
        </div>
      </div>
    </div>
    <div
      v-if="
        courseTextbookList && (searchStatus || selectLevelList.length !== 0)
      "
      class="mb-0 mr-3 text-secondary mt-2"
    >
      <div class="row col-sm-12 px-0" v-if="courseTextbookList.length !== 0">
        <strong class="col-sm-12">
          <!-- <p>filterResultList: {{ filterResultList.length }}</p>
          <p>textbookList: {{ textbookList.length }}</p>
          <p v-if="searchRname === ''">show:filterResultList</p>
          <p v-else>show:textbookList</p> -->
          <span class="mr-1" v-if="searchRname === ''">
            {{ filterResultList.length }}
          </span>
          <span class="mr-1" v-else="searchRname !== ''">
            {{ textbookList.length }}
            <!-- {{ filterResultList.length }} -->
          </span>
          {{ $t("listings-for")
          }}<span v-if="tempSearchName !== '' && searchRname !== ''">
            <span>Keyword:</span>
            “ {{ searchRname }} ”
          </span></strong
        >
        <div
          class="col-sm-12"
          v-if="selectLevelList.length !== 0 && mfilter === ''"
        >
          <span class="mr-2" v-if="searchRname === ''"
            >{{ $t("filter-only-show-book-level") }}
            {{ selectLevelList[0] }}</span
          >
        </div>
        <div class="col-sm-12" v-else-if="mfilter === 'openv'">
          <span class="mr-2">{{
            $t("filter-only-show-all-opened-video")
          }}</span>
        </div>
        <div class="col-sm-12" v-else-if="mfilter === 'openb'">
          <span class="mr-2">{{ $t("filter-only-show-all-opened-book") }}</span>
        </div>
        <div
          class="col-sm-12"
          v-else-if="selectLevelList.length === 0 && mfilter === ''"
        >
          <span class="mr-2" v-if="searchRname === ''"
            >Filter : Show all video</span
          >
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="filterModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ModalTitle1">{{ $t("filter") }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" class="zmdi zmdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <p>Filter by level</p>
            <div class="col-sm-12 row">
              <div
                v-for="(level, index) in levelLists"
                :key="level + index"
                class="col-4"
              >
                <div class="custom-control custom-checkbox mr-2">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    :id="level"
                    :value="level"
                    v-model="selectLevelList"
                  />
                  <label class="custom-control-label" :for="level"
                    >Level {{ level }}</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ApiSearchCourseResource } from "../http/apis/CourseDetail";
import { ApiSearchCollectionResource } from "../http/apis/Collection";
export default {
  name: "SearchGroup",
  data(vm) {
    return {
      typeList: [
        { text: vm.$t("all-type"), id: "all" },
        { text: vm.$t("picture-book"), id: "book" },
        { text: vm.$t("video"), id: "video" },
      ],
      searchRname: "",
      selectSortType: "",
      searchStatus: false,
      tempSearchName: "",
      textbookList: [],
      courseid: this.$route.params.courseid,
      colSortList: [],
      setAlllevel: "",
      selectLevelList: [],
      levelLists: [],
      haveLevel: false,
      courseInfo: {},
      collectionInfo: {},
      init: true,
      searchResult: [],
      filterResultList: [],
    };
  },
  props: [
    "mfilter",
    "page",
    "courseSelectLevelList",
    "courseTextbookList",
    "selectTopic",
    "selectType",
    "sortMyList",
  ],
  methods: {
    clearLevelFilter() {
      this.selectLevelList = [];
    },
    removeLevel(level) {
      let vm = this;
      let index = this.selectLevelList.indexOf(level);

      if (index !== -1) {
        vm.selectLevelList.splice(index, 1);
      }
    },
    async searchCourseResource() {
      let vm = this;
      let sType = this.selectType;
      if (this.searchRname !== "") {
        this.searchStatus = true;
        this.tempSearchName = this.searchRname;
        sType = "*";
      } else {
        this.searchStatus = false;
      }

      if (this.selectType === "all") {
        sType = "*";
      }
      if (this.mfilter === "openv") {
        sType = "video";
      }
      let searchObj = {
        type: sType,
        keyword: this.searchRname,
        topic: this.computedSelectTopic,
      };
      console.log("*****searchObj 搜尋的物件在這 = ", searchObj);
      if (this.init) {
        this.init = false;
      }
      let result = await ApiSearchCourseResource.post(this.courseid, searchObj)
        .then((response) => {
          console.log("搜尋的物件結果 = ", response);
          if (vm.selectSortType === "") {
            if (response.csrInfo.cntLevel !== 0) {
              vm.haveLevel = true;
              vm.selectSortType = "level_asc";
            } else {
              vm.haveLevel = false;
              vm.selectSortType = "unit_asc";
            }
          }
          response.record.forEach((element) => {
            if (
              element.level !== undefined &&
              element.level !== "" &&
              !vm.levelLists.includes(element.level)
            ) {
              vm.levelLists.push(element.level);
            }
            if (element.unit === undefined) {
              element.unit = "";
            }
            element.link = element.information.includes("http");
          });
          this.levelLists.sort();
          this.textbookList = response.record;

          if (response.status === "success") {
            return true;
          }
        })
        .catch((err) => {});
      if (result) {
        console.log("search 的結果在這裡!!! textbookList= ", this.textbookList);
        console.log("search 的結果在這裡!!! sortMList= ", this.sortMList);
        // console.log("selectLevelList = ", this.selectLevelList);

        if (this.searchRname !== "" && this.mfilter !== "") {
          this.$emit("getMList", this.sortMList);
        } else if (this.searchRname !== "") {
          // this.$emit("getMList", this.sortMList);
          this.$emit("getMList", this.textbookList);
        } else if (this.computedSelectTopic !== "" && this.mfilter === "") {
          this.$emit("getMList", this.textbookList);
        } else {
          this.$emit("getMList", this.textbookList);
          // this.$emit("getMList", this.sortMList);
        }
        this.$emit("getFilterInfo", this.selectLevelList, this.selectSortType);
      }
    },
    async searchCollectionResource() {
      let vm = this;
      let type = this.selectType;
      let keyword = this.searchRname;
      if (this.selectType === "all" || this.selectType === undefined) {
        type = "*";
      }
      if (this.searchRname === "") {
        keyword = "*";
      }
      if (this.searchRname !== "") {
        this.searchStatus = true;
        this.tempSearchName = this.searchRname;
      } else {
        this.searchStatus = false;
      }

      let result = await ApiSearchCollectionResource.get(
        this.userid,
        this.$route.params.cid,
        keyword,
        type
      )
        .then((response) => {
          console.log("collect response = ", response);
          if (vm.selectSortType === "") {
            if (response.moreInfo.cntLevel !== 0) {
              vm.haveLevel = true;
              vm.selectSortType = "level_asc";
            } else {
              vm.haveLevel = false;
              vm.selectSortType = "unit_asc";
            }
          }
          response.record.forEach((element) => {
            //重建
            if (
              element.level !== undefined &&
              element.level !== "" &&
              !vm.levelLists.includes(element.level)
            ) {
              vm.levelLists.push(element.level);
            }
            element.lastplay = [];
            element.last_access_all.forEach((item) => {
              if (item.last_access !== "0") {
                element.lastplay.push(item);
              }
            });
          });
          this.textbookList = response.record;

          if (response.moreInfo.cntLevel === 0) {
            let slist = [
              { text: "Sort by title A to Z", id: "title_asc" },
              { text: "Sort by title Z to A", id: "title_desc" },
              { text: "Sort by unit Smallest to Largest", id: "unit_asc" },
              { text: "Sort by unit Largest to Smallest", id: "unit_desc" },
            ];
            vm.$store.dispatch("common/setSortTypeList", slist);
          } else if (response.moreInfo.cntUnit === 0) {
            let slist = [
              { text: this.$t("sort-by-title-a-to-z"), id: "title_asc" },
              { text: this.$t("sort-by-title-z-to-a"), id: "title_desc" },
              { text: this.$t("sort-by-level-a-to-z"), id: "level_asc" },
              { text: this.$t("sort-by-level-z-to-a"), id: "level_desc" },
            ];
            vm.$store.dispatch("common/setSortTypeList", slist);
          }
          if (response.status === "success") {
            return true;
          }
        })
        .catch((err) => {});
      if (result) {
        console.log("searchCollectionResource call this.sorMlist");
        this.$emit("getMColList", this.sortMList);
      }
    },
    selectAllLevel(event) {
      const vm = this;

      if (!event.currentTarget.checked) {
        vm.selectLevelList = [];
      } else {
        //實現全選
        vm.selectLevelList = [];
        vm.levelLists.forEach(function(level, i) {
          vm.selectLevelList.push(level);
        });
      }
    },
  },
  created() {
    this.openedTextbookList = this.openedTextbookLists;
    if (this.page === "collection") {
      this.searchCollectionResource();
    }
    this.courseInfo = this.courseInfos;
    // this.selectType = "all";
  },
  computed: {
    computedSelectTopic() {
      return this.selectTopic;
    },
    courseInfos() {
      return this.$store.state.courseInfo.courseInfo;
    },
    userid() {
      return this.$store.state.auth.userid;
    },
    sortMList() {
      let sortMaterial = [];
      let openb = this.textbookList.filter((item) => {
        return item.openflag === "true" && item.note === "book";
      });
      let openv = this.textbookList.filter((item) => {
        return item.openflag === "true" && item.note === "video";
      });
      if (this.mfilter === "openm") {
        sortMaterial = this.$_sortMaterial(
          this.openedMList,
          this.selectSortType,
          this.selectLevelList
        );
      } else if (this.mfilter === "openb") {
        // 含filter
        // let level = this.selectLevelList
        // 不含filter
        let level = [];
        // console.log("openb = ", openb);
        sortMaterial = this.$_sortMaterial(openb, this.selectSortType, level);
      } else if (this.mfilter === "openv") {
        // console.log(openv);
        // 含filter
        // let level = this.selectLevelList
        // 不含filter
        let level = [];
        sortMaterial = this.$_sortMaterial(openv, this.selectSortType, level);
      } else {
        let level = this.selectLevelList;
        if (this.mfilter !== "") {
          // 不含filter
          level = [];
        }
        sortMaterial = this.$_sortMaterial(
          this.textbookList,
          this.selectSortType,
          level
        );
      }
      this.filterResultList = sortMaterial;
      return sortMaterial;
      // }
    },
    sortTypeList() {
      // console.log("sortTypeList = ", this.$store.state.common.sortTypeList);
      return this.$store.state.common.sortTypeList;
    },
    openedMList() {
      return this.textbookList.filter((item) => {
        return item.openflag === "true";
      });
    },
    openedBookList() {
      return this.textbookList.filter((item) => {
        return item.openflag === "true" && item.note === "book";
      });
    },
    openedVideoList() {
      return this.textbookList.filter((item) => {
        return item.openflag === "true" && item.note === "video";
      });
    },

    openedTextbookLists() {
      return this.$store.state.courseInfo.openedTextbookList;
    },
  },
  watch: {
    sortMyList() {
      this.filterResultList = this.sortMyList;
    },
    "$store.state.courseInfo.textBookUpdate": function(newVal, oval) {
      console.log("update material List");
      if (newVal !== oval) {
        console.log("search group call searchCourseResource");
        this.searchCourseResource();
      } else {
        console.log("監測不到textbooklist變更");
      }
    },
    courseSelectLevelList(val) {
      this.selectLevelList = val;
    },
    courseInfo() {
      console.log("get courseInfo");
      if (this.$route.name !== "CollectionDetail") {
        if (this.courseInfo.cntLevel === 0) {
          let slist = [
            { text: "Sort by title A to Z", id: "title_asc" },
            { text: "Sort by title Z to A", id: "title_desc" },
            { text: "Sort by unit Smallest to Largest", id: "unit_asc" },
            { text: "Sort by unit Largest to Smallest", id: "unit_desc" },
          ];
          this.$store.dispatch("common/setSortTypeList", slist);
        } else if (this.courseInfo.cntUnit === 0) {
          let slist = [
            { text: this.$t("sort-by-title-a-to-z"), id: "title_asc" },
            { text: this.$t("sort-by-title-z-to-a"), id: "title_desc" },
            { text: this.$t("sort-by-level-a-to-z"), id: "level_asc" },
            { text: this.$t("sort-by-level-z-to-a"), id: "level_desc" },
          ];
          this.$store.dispatch("common/setSortTypeList", slist);
        } else {
          let slist = [
            { text: this.$t("sort-by-title-a-to-z"), id: "title_asc" },
            { text: this.$t("sort-by-title-z-to-a"), id: "title_desc" },
            { text: this.$t("sort-by-level-a-to-z"), id: "level_asc" },
            { text: this.$t("sort-by-level-z-to-a"), id: "level_desc" },
            { text: "Sort by unit Smallest to Largest", id: "unit_asc" },
            { text: "Sort by unit Largest to Smallest", id: "unit_desc" },
          ];
          this.$store.dispatch("common/setSortTypeList", slist);
        }
      } else if (this.$route.name === "CollectionDetail") {
        let slist = [
          { text: this.$t("sort-by-title-a-to-z"), id: "title_asc" },
          { text: this.$t("sort-by-title-z-to-a"), id: "title_desc" },
          { text: this.$t("sort-by-level-a-to-z"), id: "level_asc" },
          { text: this.$t("sort-by-level-z-to-a"), id: "level_desc" },
          { text: this.$t("sort-by-unit-smallest-to-largest"), id: "unit_asc" },
          {
            text: this.$t("sort-by-unit-largest-to-smallest"),
            id: "unit_desc",
          },
        ];

        this.$store.dispatch("common/setSortTypeList", slist);
      }
    },
    courseInfos() {
      this.courseInfo = this.courseInfos;
    },
    selectLevelList() {
      if (this.page !== "collection" && this.selectLevelList !== []) {
        console.log("22!!@@selectLevelList@@!!22");
        this.$emit("updateTopic", "");
        console.log("selectLevelList call searchCourseResource");
        this.searchCourseResource();
      } else {
        // console.log("!!@@searchCollectionResource@@!!");
        this.searchCollectionResource();
      }
    },

    selectSortType() {
      if (this.page !== "collection") {
        console.log("selectSortType call searchCourseResource");
        this.searchCourseResource();
      } else {
        this.searchCollectionResource();
      }
    },
    openedTextbookLists() {
      this.openedTextbookList = this.openedTextbookLists;
    },
    searchRname() {
      console.log("searchRname");
      if (this.page !== "collection") {
        console.log("searchRname call searchCourseResource");
        this.searchCourseResource();
        this.$emit("updateKeyword", this.searchRname);
      } else {
        this.searchCollectionResource();
      }
    },
    selectType() {
      this.$emit("updateSelectType", this.selectType);

      if (this.page === "collection") {
        this.searchCollectionResource();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.search-group-height {
  height: 38px;
}
.select2 {
  width: 100% !important;
  min-width: 320px !important;
  height: 38px;
}
</style>
